/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperation from "../../../components/layout_operation";
import {
  // Table,
  // Input,
  // Select,
  // Modal,
  // DatePicker,
  // Checkbox,
  // Dropdown,
  // Button,
  Spin
} from "antd";
// import { DownOutlined } from "@ant-design/icons";
import JobManagement from "./job_management/JobManagement";
// import Map from "../../../ui/map_full_detail";
import Api from "../../../services/ServiceApi";
import BusManagement from "./bus_management/BusManagement";
import Cookies from "js-cookie";
// import moment from "moment";


class BusStatusChecking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "BUS STATUS CHECKING",
      // for check booking modal visible
      isBookingModalVisible: false,
      // for tab
      active: 0,
      countJob: 0,
      activeTab: parseInt(Cookies.get("activeTab")),
      tab: [{ text: "Bus Management" }, { text: "Job Management" }],
      notiData: [],
      loading: false,
    };
  }
  componentDidMount() {
    Api.post("getuserpermission", {
      "company_id": Cookies.get("companyid"),
      "operator_id": Cookies.get("operator_id"),
      "project_id": Cookies.get("project_id")
    })
      .then((res) => {
        const result = res.data.data.table.filter(data => parseInt(data.external_wf_id) === parseInt(Cookies.get("userId")));

        if (result.length === 1) {
          localStorage.setItem('permission', result[0]["status_permission"] === 0 ? 0 : 1);
        }
        else {
          localStorage.setItem('permission', 0);
        }

      })
      .catch((e) => {
        localStorage.setItem('permission', 0);
      });

  }
  // set visible of booking modal
  handleBookingModalVisible = (visibleValue) => {
    this.setState({ isBookingModalVisible: visibleValue });
  };

  // set active tab
  setActiveTab = async (value) => {
    await this.setState({
      loading: true,
    })

    await this.setState({
      activeTab: value,
    })

    await Cookies.set("activeTab", value, { expires: 1 });
    await this.setState({
      loading: false,
    });
  };

  render() {
    const { title, activeTab, tab } = this.state;

    return (
      <LayoutOperation active={8}>
        <Spin spinning={this.state.loading}>
          <div className="wrapper-header d-flex align-items-center">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-3">
                  <img
                    src={Api.absoluteUrl("/icon/asset_list_white.svg")}
                    className="mr-3"
                  />
                  <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                    {title}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* tab for bus management and job manage */}
            <div className="card-table-ma">
              <ul className="nav">
                {tab.map((item, index) => (
                  <li key={index} className="nav-item fs-14 font-mont-sb mr-1">
                    <a
                      className={
                        activeTab === index ? "nav-link active" : "nav-link"
                      }
                      onClick={() => this.setActiveTab(index)



                      }
                    >
                      {item.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="wrapper-body">
            {/* <div className={activeTab == 0 ? "d-block": "d-none"}> */}
            {activeTab == 0 ? <BusManagement /> : null}
            {/* </div> */}
            {/* <div className={activeTab == 1 ? "d-block": "d-none"}>
            <JobManagement  />  */}
            {activeTab == 1 ? <JobManagement /> : null}
            {/* </div>      */}
          </div>

        </Spin>
      </LayoutOperation>
    );
  }
}

export default BusStatusChecking;
